export default __webpack_public_path__ + "static/media/section-bg-2.17141d55.png";